import React from 'react';
import TenantModuleGate from './TenantModuleGate';

interface GranjaModuleGateProps {
  children: React.ReactNode;
}

const GranjaModuleGate: React.FC<GranjaModuleGateProps> = ({ children }) => (
  <TenantModuleGate moduleKey="granja">{children}</TenantModuleGate>
);

export default GranjaModuleGate;
